export class RouterClass {

    static readonly routes = {
        AUTH: 'auth',
        LOGIN: 'login',
        REGISTER: 'register',
        RECOVER_PASSWORD: 'recover-password',
        SELECT_CLINIC: 'select_clinic',
        CLINIC: 'clinic',
        PROFILE: 'profile',
        INSURANCES: 'insurances',
        EMPLOYEES: 'employees',
        PERMISSIONS: 'permissions',
        SETTINGS: 'settings',
        PATIENTS: 'patients',
        RECORDS: 'records',
        SCHEDULES: 'schedules',
        TIME_LINE: 'time-line',
        TIME_TABLES: 'time-tables',
        SCHEDULINGS: 'schedulings',
        DATASHEETS: 'datasheets',
        PREVIEW: 'preview',
        CALENDAR: 'calendar',
        VIEWS: 'views',
        DOCTORS: 'doctors',
        PROCEDURES: 'procedures',
        PROCEDURES_GROUPS: 'procedures-groups',
        GROUPS: 'groups',
        LIST: 'list',
        HOME: 'home',
        DASHBOARD: 'dashboard',
        PLANS: 'plans'
    }

    static readonly routerLinks = {

        auth: {
            LOGIN: ['/' + RouterClass.routes.AUTH, RouterClass.routes.LOGIN],
            REGISTER: ['/' + RouterClass.routes.AUTH, RouterClass.routes.REGISTER],
            RECOVER_PASSWORD: ['/' + RouterClass.routes.AUTH, RouterClass.routes.RECOVER_PASSWORD]
        },
        SELECT_CLINIC: ['/' + RouterClass.routes.SELECT_CLINIC],
        employees: {
            PROFILE: ['/' + RouterClass.routes.EMPLOYEES, RouterClass.routes.PROFILE],
            PERMISSIONS: ['/' + RouterClass.routes.EMPLOYEES, RouterClass.routes.PERMISSIONS],
            SETTINGS: ['/' + RouterClass.routes.EMPLOYEES, RouterClass.routes.SETTINGS]
        },
        patient: {
            PROFILE: ['/' + RouterClass.routes.PATIENTS, RouterClass.routes.PROFILE],
            INSURANCES: ['/' + RouterClass.routes.PATIENTS, RouterClass.routes.INSURANCES],
            RECORDS: ['/' + RouterClass.routes.PATIENTS, RouterClass.routes.RECORDS]
        },
        schedule: {
            INSURANCES: ['/' + RouterClass.routes.SCHEDULES, RouterClass.routes.INSURANCES],
            PROCEDURES_GROUPS: ['/' + RouterClass.routes.SCHEDULES, RouterClass.routes.PROCEDURES_GROUPS],
            DOCTORS: ['/' + RouterClass.routes.SCHEDULES, RouterClass.routes.DOCTORS],
            TIME_LINE: ['/' + RouterClass.routes.SCHEDULES, RouterClass.routes.TIME_LINE],
            SETTINGS: ['/' + RouterClass.routes.SCHEDULES, RouterClass.routes.SETTINGS],
            TIME_TABLES: ['/' + RouterClass.routes.SCHEDULES, RouterClass.routes.TIME_TABLES]
        },
        clinic: {
            PROFILE: ['/' + RouterClass.routes.CLINIC, RouterClass.routes.PROFILE],
            INSURANCES: ['/' + RouterClass.routes.CLINIC, RouterClass.routes.INSURANCES],
            REGISTER: ['/' + RouterClass.routes.CLINIC, RouterClass.routes.REGISTER],
            EMPLOYEES: ['/' + RouterClass.routes.CLINIC, RouterClass.routes.EMPLOYEES]
        },
        datasheets: {
            PREVIEW: ['/' + RouterClass.routes.DATASHEETS, RouterClass.routes.PREVIEW],
            SETTINGS: ['/' + RouterClass.routes.DATASHEETS, RouterClass.routes.SETTINGS],
        },
        procedures: {
            LIST: ['/' + RouterClass.routes.PROCEDURES, RouterClass.routes.LIST],
            GROUPS: ['/' + RouterClass.routes.PROCEDURES, RouterClass.routes.GROUPS],
        },
        insurances: {
            SETTINGS: ['/' + RouterClass.routes.INSURANCES, RouterClass.routes.SETTINGS],
            SCHEDULES: ['/' + RouterClass.routes.INSURANCES, RouterClass.routes.SCHEDULES],
            PLANS: ['/' + RouterClass.routes.INSURANCES, RouterClass.routes.PLANS],
            // DOCTORS: ['/' + RouterClass.routes.INSURANCES, RouterClass.routes.DOCTORS],
            // PATIENTS: ['/' + RouterClass.routes.INSURANCES, RouterClass.routes.PATIENTS],
        },
        calendar: {
            VIEWS: ['/' + RouterClass.routes.CALENDAR, RouterClass.routes.VIEWS],
            SCHEDULINGS: ['/' + RouterClass.routes.CALENDAR, RouterClass.routes.SCHEDULINGS],
        }
    }
}